<template>
  <div class="h-screen">
    <div class="relative h-full">
      <base-picture
        class="absolute full"
        fit="cover"
        height="531"
        :props-img="{ class: 'w-full', style: 'object-position: top right', role: 'presentation' }"
        :src="{
          sm: 'https://assets.timberland.com/image/upload/q_auto,f_auto/v1723688110/TBL-500-error-320',
          md: 'https://assets.timberland.com/image/upload/q_auto,f_auto/v1723688110/TBL-500-error-768',
          lg: 'https://assets.timberland.com/image/upload/q_auto,f_auto/v1723688110/TBL-500-error-1024',
        }"
        width="320"
      />

      <div class="absolute-0">
        <div class="pt-16 c-white container">
          <p class="pb-8 text-xl italic">
            {{ $t.maintenance.ERR5xx.seoText }}
          </p>
          <h1 class="f-col pr-4 display-3">
            <span>{{ $t.maintenance.ERR5xx.title }}</span>
            <span>{{ $t.maintenance.ERR5xx.subtitle }}</span>
          </h1>
          <p class="pb-12 pt-4 md:max-w-3/5 md:pb-8 lg:pt-6">
            {{ $t.maintenance.ERR5xx.message }}
          </p>
          <vf-button class="<md:w-full" size="md" @click="clearError">
            {{ $t.maintenance.ERR5xx.cta }}
          </vf-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
const { $feature, $t } = useNuxtApp()
useSeoMeta({ title: $t.error, robots: $feature.enableNoindexOnErrorPages ? 'noindex, nofollow' : '' })
</script>
